import {
  getRemoteConfig,
  getValue,
  getString,
  getBoolean,
  fetchAndActivate,
} from "firebase/remote-config";

export const useRemoteConfig = () => {
  const configInstance = computed(() => {
    const app = useFirebaseApp();

    return getRemoteConfig(app);
  });

  const activate = async () => {
    try {
      // Caclulate 5 minutes in milliseconds
      const fiveMinutes = 5 * 60 * 1000;
      configInstance.value.settings.minimumFetchIntervalMillis = fiveMinutes;

      await fetchAndActivate(configInstance.value);
    } catch (error) {
      // Empty
    }
  };

  const getConfigValue = (key: string) => {
    return getValue(configInstance.value, key);
  };

  const getConfigStringValue = (key: string) => {
    return getString(configInstance.value, key);
  };

  const getBoolValue = (key: string): boolean => {
    return getBoolean(configInstance.value, key);
  };

  const getJSONValue = (key: string) => {
    try {
      return JSON.parse(getConfigStringValue(key));
    } catch (error) {
      return undefined;
    }
  };

  return {
    activate,
    getConfigValue,
    getConfigStringValue,
    getBoolValue,
    getJSONValue,
  };
};
